import React, {useCallback, useEffect, useRef, useState} from 'react'
import moment from "moment"
import {
    Checkbox,
    Form,
} from "semantic-ui-react"
import {isAnsel, isSymetra, isNationwide, isAIG, isRenaissance} from '../utils/common'

const STATES = {
    FLORIDA: 'FL',
    WEST_VIRGINIA: 'WV',
    UTAH: 'UT',
};

const ChildElegibilityAgreement = (props) => {

    const {
        strings,
        isEditting,
        birthdate,
        childMaxEligibilityAge,
        curDependent,
        isChild,
        setUserAgrees,
        employer,
    } = props

    const [agrees, setAgrees] = useState(false);
    const [agreesFL, setAgreesFL] = useState(false);

    const curDependentRef = useRef(curDependent);
    const setUserAgreesRef = useRef(setUserAgrees);
    useEffect(() => {
        curDependentRef.current = curDependent;
        setUserAgreesRef.current = setUserAgrees;
    });

    const employerState = employer?.address?.state || '';
    const dependentAge = moment().diff(birthdate, 'years');

    const isFloridaEligible = useCallback(() => {
        const spSupportsFL = isAnsel() || isSymetra() || isNationwide() || isAIG() || isRenaissance();
        return spSupportsFL && employerState === STATES.FLORIDA && dependentAge >= 26 && dependentAge <= 29;
    }, [employerState, dependentAge]);

    const isFloridaOver30 = useCallback(() => {
        return isRenaissance() && employerState === STATES.FLORIDA && dependentAge >= 30;
    }, [employerState, dependentAge]);

    const isNonFloridaOver30 = useCallback(() => {
        const spSupportsAll = isAnsel() || isSymetra() || isNationwide() || isAIG() || isRenaissance();
        return spSupportsAll && employerState !== STATES.FLORIDA && dependentAge >= 30;
    }, [employerState, dependentAge]);

    const isWestVirginiaEligible = useCallback(() => {
        const spSupportsWV = isSymetra() || isAnsel();
        const meetsWVAge = (employerState === STATES.WEST_VIRGINIA && dependentAge >= 25) ||
            (employerState !== STATES.WEST_VIRGINIA && dependentAge >= 26 && dependentAge < 30);
        return spSupportsWV && meetsWVAge && !isFloridaEligible();
    }, [employerState, dependentAge, isFloridaEligible]);

    const isStandardEligible = useCallback(() => {
        const spSupportsStandard = isAIG() || isRenaissance() || isNationwide();
        return spSupportsStandard && dependentAge >= 26 && dependentAge < 30 && !isFloridaEligible();
    }, [dependentAge, isFloridaEligible]);

    const isUtahRenaissanceEligible = useCallback(() => {
        return isRenaissance() && employerState === STATES.UTAH && dependentAge >= 26;
    }, [employerState, dependentAge]);

    useEffect(()=>{
        const newValue = {...curDependentRef.current}
        if(agrees && isFloridaEligible()) {
            newValue.userAgrees = agrees;
        }else {
            newValue.userAgrees = agrees || agreesFL;
        }
        setUserAgreesRef.current(newValue)
    },[agrees, agreesFL, isFloridaEligible]);


    const showFloridaAcknowledgement = () => isFloridaEligible();
    const showFloridaOver30Acknowledgement = () => isFloridaOver30();
    const showNonFloridaOver30Acknowledgement = () => isNonFloridaOver30();
    const showWestVirginiaAcknowledgement = () => isWestVirginiaEligible();
    const showUtahAcknowledgement = () => isUtahRenaissanceEligible();
    const showStandardAcknowledgement = () => isStandardEligible();
    const showAnyAcknowledgement = () => showFloridaAcknowledgement() || showFloridaOver30Acknowledgement() || showNonFloridaOver30Acknowledgement() || showWestVirginiaAcknowledgement() || showStandardAcknowledgement() || showUtahAcknowledgement();
    const getIncapableString = () => isUtahRenaissanceEligible() ? strings.cIsIncapableUT : strings.cIsIncapable;
    const getProofIsString = () => isUtahRenaissanceEligible() ? strings.cProofIsUT : strings.cProofIs;

    const renderHeader = () => (
        <>
            <b style={{lineHeight: "21px"}}>
                {showFloridaAcknowledgement() ? strings.inOrderToDetermin : strings.inOrderForChildToQualify}
            </b>
        </>
    );


    const renderFooter = () =>
        showFloridaAcknowledgement() ? (
            <p style={{fontStyle: "italic", fontSize: "12px", lineHeight: "18px"}}>
                {strings.pleaseNoteAboveCriteria}
            </p>
        ) : null;

    return (
        <>
            {((isEditting && dependentAge >= childMaxEligibilityAge) || showAnyAcknowledgement()) && isChild &&
                <>
                    <Form.Field>
                        <div className={'childEligibilityForm small'}>
                            {renderHeader()}
                            {showFloridaAcknowledgement() &&
                                <>
                                    <ul>
                                        <li>{strings.cIsUnmarried}</li>
                                        <li>{strings.cIsFLResident}</li>
                                    </ul>
                                    <Checkbox
                                        label={strings.iAckTheCriteriaAppliesToMyChild}
                                        checked={agreesFL}
                                        onClick={()=>{
                                            setAgreesFL(!agreesFL)
                                        }}
                                        style={{marginBottom:"15px"}}
                                    />
                                    <ul>
                                        <li>{getIncapableString()}</li>
                                        <li>{strings.cIsChiefly}</li>
                                        <li>{getProofIsString()}</li>
                                    </ul>
                                    <Checkbox
                                        label={strings.iAckTheCriteriaAppliesToMyChild}
                                        checked={agrees}
                                        onClick={()=>{
                                            setAgrees(!agrees)
                                        }}
                                        style={{marginBottom:"15px"}}
                                    />
                                </>
                            }
                            {!showFloridaAcknowledgement() && showAnyAcknowledgement() &&
                                <>
                                    <ul>
                                        <li>{getIncapableString()}</li>
                                        <li>{strings.cIsChiefly}</li>
                                        <li>{getProofIsString()}</li>
                                    </ul>
                                    <Checkbox
                                        label={strings.iAgree}
                                        checked={agrees}
                                        onClick={()=>{
                                            setAgrees(!agrees)
                                        }}
                                        style={{marginBottom:"15px"}}
                                    />
                                </>
                            }
                            {renderFooter()}
                        </div>
                    </Form.Field>
                </>
            }
        </>
    )
}

export default ChildElegibilityAgreement;